import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { Container, Feed as SemanticFeed, Segment, Header, Icon } from 'semantic-ui-react';
import { posts } from '../services/api';

function Feed() {
  const { data: feedItems, isLoading } = useQuery({
    queryKey: ['feed'],
    queryFn: () => posts.list({ type: 'feed' }),
  });

  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - Activity Feed</title>
      </Helmet>

      <Container>
        <Segment vertical>
          <Header as="h1">Activity Feed</Header>

          {isLoading ? (
            <Segment loading />
          ) : (
            <SemanticFeed>
              {feedItems?.data?.map((item) => (
                <SemanticFeed.Event key={item.id}>
                  <SemanticFeed.Label>
                    <Icon name={getIconForType(item.type)} />
                  </SemanticFeed.Label>
                  <SemanticFeed.Content>
                    <SemanticFeed.Summary>
                      <SemanticFeed.User>{item.user.name}</SemanticFeed.User>
                      {getActionText(item.type)}
                      <SemanticFeed.Date>{item.created_at}</SemanticFeed.Date>
                    </SemanticFeed.Summary>
                    <SemanticFeed.Extra text>
                      {item.content}
                    </SemanticFeed.Extra>
                    {item.link && (
                      <SemanticFeed.Meta>
                        <a href={item.link}>View Details</a>
                      </SemanticFeed.Meta>
                    )}
                  </SemanticFeed.Content>
                </SemanticFeed.Event>
              ))}
            </SemanticFeed>
          )}
        </Segment>
      </Container>
    </>
  );
}

function getIconForType(type) {
  switch (type) {
    case 'recipe':
      return 'book';
    case 'forum':
      return 'comments';
    case 'comment':
      return 'comment';
    default:
      return 'circle';
  }
}

function getActionText(type) {
  switch (type) {
    case 'recipe':
      return ' created a new recipe';
    case 'forum':
      return ' started a new forum discussion';
    case 'comment':
      return ' commented on';
    default:
      return ' performed an action';
  }
}

export default Feed; 